import { CompareDocumentsPanel } from '@/features/compare/CompareDocumentsPanel'

export function CompareDocumentsPage() {
    return (
        <CompareDocumentsPanel />
    )
}